/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppShellComponent } from './app-shell.component';
import { SystemPanelFrameModule } from '../components/system-panel-frame';
import { SysqueAlertModule } from 'libs/sysque/shared/ui/src/lib/components/sysque-alert';
import { DxPopupModule, DxProgressBarModule } from 'devextreme-angular';
import { ElectricalToolbeltModule } from '../tool-belt/electrical-toolbelt.module';
import { SysqueProgressBarModule } from '../../../../../shared/ui/src/lib/components/sysque-progress-bar';
import { AcrylicSurfaceModule } from '../acrylic-surface';

@NgModule({
  declarations: [AppShellComponent],
  imports: [
    CommonModule,
    SystemPanelFrameModule,
    SysqueAlertModule,
    DxProgressBarModule,
    DxPopupModule,
    ElectricalToolbeltModule,
    SysqueProgressBarModule,
    AcrylicSurfaceModule
  ],
  exports: [AppShellComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppShellModule {}
